import { useTranslation } from 'react-i18next'
import * as yup from 'yup'

import { LoginFormValues } from '../login-form.interface'

export const LoginValidationSchema = () => {
  const { t } = useTranslation()

  return yup.object<LoginFormValues>({
    email: yup.string().email(t('emailErrors.invalidEmail')).required(t('emailErrors.emailRequired')),
    password: yup.string().required(t('auth.register.errors.passwordRequired')),
  })
}
